import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1be8333e"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1be8333e')) {
      api.createRecord('1be8333e', component.options)
    } else {
      api.reload('1be8333e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1be8333e", function () {
      api.rerender('1be8333e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nested/menu1/menu1-1/index.vue"
export default component.exports